import { HttpResult } from 'widgets-for-react'
import {
  Announcement,
  DrupalAnnouncementsConfigPage,
  DrupalLink,
} from './announcementBar.types'
import { AnnouncementBarProps } from '../../../components'

export const getAnnouncements = async (): Promise<HttpResult<Announcement | undefined>> => {
  try {
    let headers = new Headers()
    headers.append('content-type', 'application/json')
    headers.append('X-XSRF-TOKEN', (document.getElementsByName('__RequestVerificationToken')[0] as any).value)

    let res = await fetch(`/api/drupal/config_page/announcements`, {
      method: 'get', credentials: 'include', headers: headers
    })

    if (res.status == 404) return { kind: 'result', status: 404, value: undefined }
    if (!res.ok) throw Error(res.statusText)

    let configPages = await res.json() as DrupalAnnouncementsConfigPage[]
    const announcements = parseAnnouncements(configPages)
    return {
      kind: 'result',
      status: 200,
      value: announcements.length < 1 ? undefined : announcements[0]
    }
  } catch (e) {
    console.error('Error when fetching announcements')
    console.error(e)

    return {
      kind: 'failed',
      status: 500
    }
  }
}

export const parseAnnouncements = (configPages: DrupalAnnouncementsConfigPage[]): Announcement[] =>
  (configPages[0]?.field_announcements ?? [])
    .map(({ target_id, target }) => ({
      id: target_id,
      text: target?.field_title?.[0]?.value ?? '',
      theme: parseTheme(target?.field_rpb_background_color?.[0]?.value),
      link: parseLink(target?.field_link?.[0]),
      start: parseDate(target?.field_start_date?.[0]?.value),
      end: parseDate(target?.field_end_date?.[0]?.value),
    }))
    .filter((announcement) => announcement.text != '')
    .filter(isActive)
    .sort(byStartDate)


const byStartDate = (l: Announcement, r: Announcement): number => {
  if (l.start == undefined) return r.start == undefined ? 0 : -1
  if (r.start == undefined) return 1
  return l.start.getTime() - r.start.getTime()
}

const parseTheme = (value: string | undefined): AnnouncementBarProps['theme'] =>
  value == 'red' || value == 'black' ? value : 'pink'

const parseDate = (value: string | undefined): Date | undefined => {
  if (!value) return undefined

  const date = new Date(value)
  return isNaN(date.getTime()) ? undefined : date
}

const parseLink = (link: DrupalLink | undefined): AnnouncementBarProps['link'] => {
  const url = link?.processed_url ?? link?.uri
  return link && url && link.title ? { url: url, title: link.title } : undefined
}

const isActive = (announcement: Announcement): boolean => {
  const now = new Date()
  return (announcement.start == undefined || announcement.start <= now) &&
  (announcement.end == undefined || announcement.end >= now)
}